export enum SliderMode {
    Multiple = 'multiple',
    Single = 'single'
}
